/**SCSS */
import "./_spacer.scss";

export const Spacer = ({ marginTop = "", marginBottom = "", marginLeft = "", marginRight = "" }) => {
    return <hr className="spacer" style={{ marginTop, marginBottom, marginLeft, marginRight }} />;
};

export default Spacer;
